import { render, staticRenderFns } from "./customerNetwork.vue?vue&type=template&id=f72d6cba&scoped=true"
import script from "./customerNetwork.vue?vue&type=script&lang=js"
export * from "./customerNetwork.vue?vue&type=script&lang=js"
import style0 from "./customerNetwork.vue?vue&type=style&index=0&id=f72d6cba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72d6cba",
  null
  
)

export default component.exports